var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect } from 'react';
import { useAuthProvider } from '#context';
import { Amplitude } from '#integrations';
import { getAmplitudeApiKey } from '#services';
export const useSetAmplitudeUser = () => {
    _react_refresh_temp_1();
    const { currentUser } = useAuthProvider();
    const userId = currentUser?.id;
    useEffect(() => {
        if (userId && getAmplitudeApiKey()) {
            try {
                Amplitude.setUserId(userId);
            }
            catch (error) {
                // eslint-disable-next-line no-console -- log if 3rd party fails
                console.error(error);
            }
        }
    }, [userId]);
};
_react_refresh_temp_1(useSetAmplitudeUser, "Z4NJ5jv5zaLOrEKKBCFaPOY+Pms=", false, () => [useAuthProvider]);
